import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import Dashboard from "./components/Dashboard";
import { isAuthenticated } from "./services/auth";
import PageLogin from "./components/LoginPage";

interface IProps {
  exact?: boolean;
  path: string;
  component: React.ComponentType<any>;
}

const PrivateRoute = ({ component: Component, ...rest }: IProps) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/", state: { from: props.location } }} />
      )
    }
  />
);

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/" component={() => <PageLogin />} />
      <PrivateRoute path="/app" component={() => <Dashboard />} />
      <Route component={PageLogin} />
    </Switch>
  </BrowserRouter>
);

export default Routes;
